__turbopack_context__.v({
  "ask": "LessonNotebook-module__8pV3pa__ask",
  "askSection": "LessonNotebook-module__8pV3pa__askSection",
  "asks": "LessonNotebook-module__8pV3pa__asks",
  "body": "LessonNotebook-module__8pV3pa__body",
  "chevron": "LessonNotebook-module__8pV3pa__chevron",
  "count": "LessonNotebook-module__8pV3pa__count",
  "headerRow": "LessonNotebook-module__8pV3pa__headerRow",
  "list": "LessonNotebook-module__8pV3pa__list",
  "muted": "LessonNotebook-module__8pV3pa__muted",
  "notebook": "LessonNotebook-module__8pV3pa__notebook",
  "phrase": "LessonNotebook-module__8pV3pa__phrase",
  "phraseText": "LessonNotebook-module__8pV3pa__phraseText",
  "review": "LessonNotebook-module__8pV3pa__review",
  "subtitle": "LessonNotebook-module__8pV3pa__subtitle",
  "tags": "LessonNotebook-module__8pV3pa__tags",
  "title": "LessonNotebook-module__8pV3pa__title",
  "toggle": "LessonNotebook-module__8pV3pa__toggle",
  "translation": "LessonNotebook-module__8pV3pa__translation",
  "weak": "LessonNotebook-module__8pV3pa__weak",
  "weakConcept": "LessonNotebook-module__8pV3pa__weakConcept",
});
